<template>
  <div v-if="businessUnits?.length > 1">
    <component :is="headingTag" :class="headingClass">
      {{ tbu("selectedBusinessUnit") }}<template v-if="required"> *</template>
    </component>
    <div
      class="is-flex is-align-items-center is-justify-content-space-between mb-2"
      v-if="selectedBusinessUnit"
    >
      <b>{{ selectedBusinessUnit.name }}</b>
      <div>
        <button
          class="c-button c-button--small is-danger ml-1"
          @click.stop.prevent="handleRemove"
        >
          <span class="icon is-small">
            <i class="fas fa-times"></i>
          </span>
        </button>
      </div>
    </div>

    <BusinessunitSelection
      v-if="!selectedBusinessUnit"
      :business-units="businessUnits"
      :preselected-business-unit-id="preselectedBusinessUnitId"
      @selected-business-unit="handleSelected"
    />
  </div>
</template>

<script>
import BusinessunitSelection from "./BusinessunitSelection.vue";

export default {
  components: {
    BusinessunitSelection
  },
  props: {
    businessUnits: {
      type: Array,
      default: () => []
    },
    selectedBusinessUnit: {
      type: Object,
      default: null
    },
    preselectedBusinessUnitId: {
      type: String,
      default: null
    },
    // Appends a "*" to the label
    required: {
      type: Boolean,
      default: false
    },
    // Matches the heading element each form used before this was extracted
    headingTag: {
      type: String,
      default: "h6"
    },
    headingClass: {
      type: String,
      default: "title is-6"
    }
  },
  emits: ["selected-business-unit", "remove-business-unit"],
  methods: {
    handleSelected(data) {
      this.$emit("selected-business-unit", data);
    },
    handleRemove() {
      this.$emit("remove-business-unit");
    }
  }
};
</script>
